(function () {
  'use strict';

  /* ── TRANSLATIONS ─────────────────────────────────────────── */
  var T = {
    fr: {
      name:'Assistante Lesly Curlz', status:'En ligne · Répond en quelques secondes',
      greeting:'Bonjour ! 💜 Je suis là pour vous aider avec la Crème Restructurante Lesly Curlz.\n\nQue souhaitez-vous savoir ?',
      placeholder:'Tapez votre message...', email_cta:'📧 Envoyer un email', back:'← Retour au menu',
      other_msg:'Pour toute question complexe, notre équipe est là pour vous 💜\n\nÉcrivez-nous, nous répondons sous 24h !',
      q:{ ingredients:'🌿 Ingrédients', use:'✨ Comment l\'utiliser', delivery:'🚚 Livraison', returns:'↩️ Retours', payment:'💳 Paiement', results:'⭐ Résultats & efficacité', other:'📧 Parler à l\'équipe' },
      a:{
        ingredients:'🌿 Formule 98% naturelle :\n\n🥥 Huile de Coco — hydratation profonde\n🌾 Huile de Jojoba — nourrit la fibre capillaire\n💧 Beurre de Karité — scelle l\'hydratation\n🌸 Aloe Vera — adoucit et démêle\n\n✅ Sans sulfates · Sans parabens · Sans silicones',
        use:'✨ Application en 3 étapes :\n\n1️⃣ Appliquez sur cheveux lavés, encore humides\n2️⃣ Répartissez de la racine aux pointes\n3️⃣ Laissez sécher à l\'air libre ou diffusez\n\n💡 Conseil : utilisez comme leave-in ou définissant. Renouvelez tous les 2–3 jours.',
        delivery:'🚚 Délais de livraison :\n\n📦 France : 2–3 jours ouvrés\n🇧🇪 Belgique / 🇨🇭 Suisse : 3–5 jours\n🌍 Reste de l\'Europe : 4–7 jours\n\n🎁 Livraison offerte dès 35€ d\'achat !',
        returns:'↩️ Retours & remboursements :\n\nVous avez 30 jours pour retourner le produit si vous n\'êtes pas satisfaite.\n\n✅ Retour gratuit\n✅ Remboursement intégral sous 5–7 jours\n\nContactez-nous par email et on s\'occupe de tout 💜',
        payment:'💳 Moyens de paiement acceptés :\n\nVISA · Mastercard · PayPal\nApple Pay · Google Pay · CB\n\n🔒 Paiement 100% sécurisé et crypté',
        results:'⭐ Résultats observés :\n\nDès la 1ère application :\n✨ Boucles définies et brillantes\n💧 Hydratation intense, tenue 72h\n🛡️ Frisottis réduit jusqu\'à 72h\n\n4,9/5 ⭐ — plus de 200 clientes satisfaites',
      }
    },
    en: {
      name:'Lesly Curlz Assistant', status:'Online · Responds in seconds',
      greeting:'Hello! 💜 I\'m here to help you with the Lesly Curlz Restructuring Cream.\n\nWhat would you like to know?',
      placeholder:'Type your message...', email_cta:'📧 Send an email', back:'← Back to menu',
      other_msg:'For any complex question, our team is here for you 💜\n\nWrite to us, we reply within 24h!',
      q:{ ingredients:'🌿 Ingredients', use:'✨ How to use it', delivery:'🚚 Delivery', returns:'↩️ Returns', payment:'💳 Payment', results:'⭐ Results & efficacy', other:'📧 Talk to our team' },
      a:{
        ingredients:'🌿 98% natural formula:\n\n🥥 Coconut Oil — deep hydration\n🌾 Jojoba Oil — nourishes hair fiber\n💧 Shea Butter — seals moisture in\n🌸 Aloe Vera — softens and detangles\n\n✅ Sulfate-free · Paraben-free · Silicone-free',
        use:'✨ Application in 3 steps:\n\n1️⃣ Apply on washed, still damp hair\n2️⃣ Distribute from roots to ends\n3️⃣ Air dry or use a diffuser\n\n💡 Tip: use as a leave-in or curl definer. Reapply every 2–3 days.',
        delivery:'🚚 Delivery times:\n\n📦 France: 2–3 business days\n🇧🇪 Belgium / 🇨🇭 Switzerland: 3–5 days\n🌍 Rest of Europe: 4–7 days\n\n🎁 Free shipping from €35!',
        returns:'↩️ Returns & refunds:\n\nYou have 30 days to return the product if you\'re not satisfied.\n\n✅ Free return\n✅ Full refund within 5–7 days\n\nContact us by email and we\'ll take care of everything 💜',
        payment:'💳 Accepted payment methods:\n\nVISA · Mastercard · PayPal\nApple Pay · Google Pay · CB\n\n🔒 100% secure and encrypted payment',
        results:'⭐ Observed results:\n\nFrom the 1st application:\n✨ Defined and shiny curls\n💧 Intense hydration, lasting 72h\n🛡️ Frizz reduced up to 72h\n\n4.9/5 ⭐ — 200+ satisfied customers',
      }
    },
    de: {
      name:'Lesly Curlz Assistentin', status:'Online · Antwortet in Sekunden',
      greeting:'Hallo! 💜 Ich bin hier, um dir bei der Lesly Curlz Pflegecreme zu helfen.\n\nWas möchtest du wissen?',
      placeholder:'Nachricht eingeben...', email_cta:'📧 E-Mail senden', back:'← Zurück zum Menü',
      other_msg:'Für komplexe Fragen ist unser Team für dich da 💜\n\nSchreib uns, wir antworten innerhalb von 24h!',
      q:{ ingredients:'🌿 Zutaten', use:'✨ Anwendung', delivery:'🚚 Lieferung', returns:'↩️ Rückgabe', payment:'💳 Zahlung', results:'⭐ Ergebnisse', other:'📧 Team kontaktieren' },
      a:{
        ingredients:'🌿 98% natürliche Formel:\n\n🥥 Kokosöl — tiefe Feuchtigkeitspflege\n🌾 Jojobaöl — nährt die Haarfaser\n💧 Sheabutter — versiegelt Feuchtigkeit\n🌸 Aloe Vera — glättet und entwirrt\n\n✅ Ohne Sulfate · Ohne Parabene · Ohne Silikone',
        use:'✨ Anwendung in 3 Schritten:\n\n1️⃣ Auf gewaschenem, noch feuchtem Haar auftragen\n2️⃣ Von den Wurzeln bis zu den Spitzen verteilen\n3️⃣ An der Luft trocknen oder Diffusor verwenden\n\n💡 Tipp: als Leave-in oder Locken-Definierer. Alle 2–3 Tage erneuern.',
        delivery:'🚚 Lieferzeiten:\n\n📦 Frankreich: 2–3 Werktage\n🇧🇪 Belgien / 🇨🇭 Schweiz: 3–5 Tage\n🌍 Restliches Europa: 4–7 Tage\n\n🎁 Kostenloser Versand ab 35€!',
        returns:'↩️ Rückgabe & Erstattung:\n\nDu hast 30 Tage, das Produkt zurückzugeben.\n\n✅ Kostenlose Rücksendung\n✅ Vollständige Erstattung in 5–7 Tagen\n\nKontaktiere uns per E-Mail 💜',
        payment:'💳 Akzeptierte Zahlungsmethoden:\n\nVISA · Mastercard · PayPal\nApple Pay · Google Pay · CB\n\n🔒 100% sicheres und verschlüsseltes Zahlung',
        results:'⭐ Beobachtete Ergebnisse:\n\nAb der 1. Anwendung:\n✨ Definierte und glänzende Locken\n💧 Intensive Feuchtigkeit, hält 72h\n🛡️ Frizz bis zu 72h reduziert\n\n4,9/5 ⭐ — 200+ zufriedene Kundinnen',
      }
    },
    nl: {
      name:'Lesly Curlz Assistent', status:'Online · Antwoordt in seconden',
      greeting:'Hallo! 💜 Ik ben hier om je te helpen met de Lesly Curlz Herstructurerende Crème.\n\nWat wil je weten?',
      placeholder:'Typ je bericht...', email_cta:'📧 E-mail sturen', back:'← Terug naar menu',
      other_msg:'Voor complexe vragen is ons team er voor jou 💜\n\nSchrijf ons, we reageren binnen 24 uur!',
      q:{ ingredients:'🌿 Ingrediënten', use:'✨ Gebruik', delivery:'🚚 Levering', returns:'↩️ Retour', payment:'💳 Betaling', results:'⭐ Resultaten', other:'📧 Team contacteren' },
      a:{
        ingredients:'🌿 98% natuurlijke formule:\n\n🥥 Kokosolie — diepe hydratatie\n🌾 Jojobaolíe — voedt de haarvezel\n💧 Sheaboter — sluit vocht in\n🌸 Aloë Vera — verzacht en ontklitt\n\n✅ Zonder sulfaten · Zonder parabenen · Zonder siliconen',
        use:'✨ Gebruik in 3 stappen:\n\n1️⃣ Aanbrengen op gewassen, nog vochtig haar\n2️⃣ Verdelen van wortels tot punten\n3️⃣ Aan de lucht laten drogen of diffuser gebruiken\n\n💡 Tip: als leave-in of krul definieerder. Elke 2–3 dagen vernieuwen.',
        delivery:'🚚 Levertijden:\n\n📦 Frankrijk: 2–3 werkdagen\n🇧🇪 België / 🇨🇭 Zwitserland: 3–5 dagen\n🌍 Overig Europa: 4–7 dagen\n\n🎁 Gratis levering vanaf €35!',
        returns:'↩️ Retour & terugbetaling:\n\nJe hebt 30 dagen om het product terug te sturen.\n\n✅ Gratis retour\n✅ Volledige terugbetaling in 5–7 dagen\n\nNeem contact met ons op per e-mail 💜',
        payment:'💳 Geaccepteerde betaalmethoden:\n\nVISA · Mastercard · PayPal\nApple Pay · Google Pay · CB\n\n🔒 100% veilige en versleutelde betaling',
        results:'⭐ Waargenomen resultaten:\n\nVanaf de 1e toepassing:\n✨ Gedefinieerde en glanzende krullen\n💧 Intense hydratatie, houdt 72u\n🛡️ Kroes tot 72u verminderd\n\n4,9/5 ⭐ — 200+ tevreden klanten',
      }
    },
    es: {
      name:'Asistente Lesly Curlz', status:'En línea · Responde en segundos',
      greeting:'¡Hola! 💜 Estoy aquí para ayudarte con la Crema Reestructurante Lesly Curlz.\n\n¿Qué quieres saber?',
      placeholder:'Escribe tu mensaje...', email_cta:'📧 Enviar email', back:'← Volver al menú',
      other_msg:'Para cualquier pregunta compleja, nuestro equipo está aquí para ti 💜\n\n¡Escríbenos, respondemos en 24h!',
      q:{ ingredients:'🌿 Ingredientes', use:'✨ Cómo usarla', delivery:'🚚 Envío', returns:'↩️ Devoluciones', payment:'💳 Pago', results:'⭐ Resultados', other:'📧 Contactar al equipo' },
      a:{
        ingredients:'🌿 Fórmula 98% natural:\n\n🥥 Aceite de Coco — hidratación profunda\n🌾 Aceite de Jojoba — nutre la fibra capilar\n💧 Manteca de Karité — sella la hidratación\n🌸 Aloe Vera — suaviza y desenreda\n\n✅ Sin sulfatos · Sin parabenos · Sin siliconas',
        use:'✨ Aplicación en 3 pasos:\n\n1️⃣ Aplica en cabello lavado, aún húmedo\n2️⃣ Distribuye de raíces a puntas\n3️⃣ Deja secar al aire o usa difusor\n\n💡 Consejo: úsala como leave-in o definidor. Renueva cada 2–3 días.',
        delivery:'🚚 Plazos de entrega:\n\n📦 Francia: 2–3 días laborables\n🇧🇪 Bélgica / 🇨🇭 Suiza: 3–5 días\n🌍 Resto de Europa: 4–7 días\n\n🎁 ¡Envío gratis a partir de 35€!',
        returns:'↩️ Devoluciones y reembolsos:\n\nTienes 30 días para devolver el producto.\n\n✅ Devolución gratuita\n✅ Reembolso completo en 5–7 días\n\nContáctanos por email 💜',
        payment:'💳 Métodos de pago aceptados:\n\nVISA · Mastercard · PayPal\nApple Pay · Google Pay · CB\n\n🔒 Pago 100% seguro y cifrado',
        results:'⭐ Resultados observados:\n\nDesde la 1ª aplicación:\n✨ Rizos definidos y brillantes\n💧 Hidratación intensa, dura 72h\n🛡️ Frizz reducido hasta 72h\n\n4,9/5 ⭐ — más de 200 clientas satisfechas',
      }
    },
    it: {
      name:'Assistente Lesly Curlz', status:'Online · Risponde in pochi secondi',
      greeting:'Ciao! 💜 Sono qui per aiutarti con la Crema Ristrutturante Lesly Curlz.\n\nCosa vuoi sapere?',
      placeholder:'Scrivi il tuo messaggio...', email_cta:'📧 Invia email', back:'← Torna al menu',
      other_msg:'Per qualsiasi domanda complessa, il nostro team è qui per te 💜\n\nScrivici, rispondiamo entro 24h!',
      q:{ ingredients:'🌿 Ingredienti', use:'✨ Come usarla', delivery:'🚚 Consegna', returns:'↩️ Resi', payment:'💳 Pagamento', results:'⭐ Risultati', other:'📧 Contattare il team' },
      a:{
        ingredients:'🌿 Formula al 98% naturale:\n\n🥥 Olio di Cocco — idratazione profonda\n🌾 Olio di Jojoba — nutre la fibra capillare\n💧 Burro di Karité — sigilla l\'idratazione\n🌸 Aloe Vera — ammorbidisce e districar\n\n✅ Senza solfati · Senza parabeni · Senza siliconi',
        use:'✨ Applicazione in 3 passi:\n\n1️⃣ Applica su capelli lavati, ancora umidi\n2️⃣ Distribuisci dalle radici alle punte\n3️⃣ Lascia asciugare all\'aria o usa il diffusore\n\n💡 Consiglio: usala come leave-in o definente. Rinnova ogni 2–3 giorni.',
        delivery:'🚚 Tempi di consegna:\n\n📦 Francia: 2–3 giorni lavorativi\n🇧🇪 Belgio / 🇨🇭 Svizzera: 3–5 giorni\n🌍 Resto d\'Europa: 4–7 giorni\n\n🎁 Spedizione gratuita da €35!',
        returns:'↩️ Resi e rimborsi:\n\nHai 30 giorni per restituire il prodotto.\n\n✅ Reso gratuito\n✅ Rimborso completo in 5–7 giorni\n\nContattaci per email 💜',
        payment:'💳 Metodi di pagamento accettati:\n\nVISA · Mastercard · PayPal\nApple Pay · Google Pay · CB\n\n🔒 Pagamento 100% sicuro e criptato',
        results:'⭐ Risultati osservati:\n\nDalla 1ª applicazione:\n✨ Ricci definiti e lucenti\n💧 Idratazione intensa, dura 72h\n🛡️ Crespo ridotto fino a 72h\n\n4,9/5 ⭐ — oltre 200 clienti soddisfatte',
      }
    },
    pt: {
      name:'Assistente Lesly Curlz', status:'Online · Responde em segundos',
      greeting:'Olá! 💜 Estou aqui para te ajudar com o Creme Reestruturante Lesly Curlz.\n\nO que queres saber?',
      placeholder:'Escreve a tua mensagem...', email_cta:'📧 Enviar email', back:'← Voltar ao menu',
      other_msg:'Para qualquer questão complexa, a nossa equipa está aqui para ti 💜\n\nEscreve-nos, respondemos em 24h!',
      q:{ ingredients:'🌿 Ingredientes', use:'✨ Como usar', delivery:'🚚 Entrega', returns:'↩️ Devoluções', payment:'💳 Pagamento', results:'⭐ Resultados', other:'📧 Contactar equipa' },
      a:{
        ingredients:'🌿 Fórmula 98% natural:\n\n🥥 Óleo de Coco — hidratação profunda\n🌾 Óleo de Jojoba — nutre a fibra capilar\n💧 Manteiga de Karité — sela a hidratação\n🌸 Aloe Vera — suaviza e destrinça\n\n✅ Sem sulfatos · Sem parabenos · Sem silicones',
        use:'✨ Aplicação em 3 passos:\n\n1️⃣ Aplica no cabelo lavado, ainda húmido\n2️⃣ Distribui das raízes às pontas\n3️⃣ Deixa secar ao ar ou usa difusor\n\n💡 Dica: usa como leave-in ou definidor. Renova a cada 2–3 dias.',
        delivery:'🚚 Prazos de entrega:\n\n📦 França: 2–3 dias úteis\n🇧🇪 Bélgica / 🇨🇭 Suíça: 3–5 dias\n🌍 Resto da Europa: 4–7 dias\n\n🎁 Entrega gratuita a partir de 35€!',
        returns:'↩️ Devoluções e reembolsos:\n\nTens 30 dias para devolver o produto.\n\n✅ Devolução gratuita\n✅ Reembolso completo em 5–7 dias\n\nContacta-nos por email 💜',
        payment:'💳 Métodos de pagamento aceites:\n\nVISA · Mastercard · PayPal\nApple Pay · Google Pay · CB\n\n🔒 Pagamento 100% seguro e encriptado',
        results:'⭐ Resultados observados:\n\nDesde a 1ª aplicação:\n✨ Caracóis definidos e brilhantes\n💧 Hidratação intensa, dura 72h\n🛡️ Frizz reduzido até 72h\n\n4,9/5 ⭐ — mais de 200 clientes satisfeitas',
      }
    }
  };

  /* ── HELPERS ──────────────────────────────────────────────── */
  var LC_BROWSER_MAP = {
    'fr':'fr','de':'de','nl':'nl','es':'es','it':'it','pt':'pt','en':'en'
  };

  function detectLang() {
    var saved = localStorage.getItem('leslyCurlzLang');
    if (saved && T[saved]) return saved;
    var browser = (navigator.language || 'fr').toLowerCase().slice(0, 2);
    return LC_BROWSER_MAP[browser] || 'fr';
  }

  function $(id) { return document.getElementById(id); }

  /* ── STATE ────────────────────────────────────────────────── */
  var lang, t, email, isOpen = false;

  /* ── BOT MESSAGE ──────────────────────────────────────────── */
  function botMsg(text, delay) {
    var msgs = $('lcMsgs');
    var typing = document.createElement('div');
    typing.className = 'lc-bubble lc-bubble-bot';
    typing.innerHTML = '<div class="lc-typing"><span></span><span></span><span></span></div>';
    msgs.appendChild(typing);
    msgs.scrollTop = msgs.scrollHeight;
    return new Promise(function(resolve) {
      setTimeout(function() {
        typing.remove();
        var b = document.createElement('div');
        b.className = 'lc-bubble lc-bubble-bot';
        b.textContent = text;
        msgs.appendChild(b);
        msgs.scrollTop = msgs.scrollHeight;
        resolve();
      }, delay || 750);
    });
  }

  function userMsg(text) {
    var msgs = $('lcMsgs');
    var b = document.createElement('div');
    b.className = 'lc-bubble lc-bubble-user';
    b.textContent = text;
    msgs.appendChild(b);
    msgs.scrollTop = msgs.scrollHeight;
  }

  /* ── QUICK REPLIES ────────────────────────────────────────── */
  function setQR(items) {
    var qr = $('lcQR');
    qr.innerHTML = '';
    items.forEach(function(item) {
      var btn = document.createElement('button');
      btn.className = 'lc-qr';
      btn.textContent = item.label;
      btn.onclick = item.fn;
      qr.appendChild(btn);
    });
  }

  function showMenu() {
    setQR([
      { label: t.q.ingredients, fn: function(){ handleFAQ('ingredients'); } },
      { label: t.q.use,         fn: function(){ handleFAQ('use'); } },
      { label: t.q.delivery,    fn: function(){ handleFAQ('delivery'); } },
      { label: t.q.returns,     fn: function(){ handleFAQ('returns'); } },
      { label: t.q.payment,     fn: function(){ handleFAQ('payment'); } },
      { label: t.q.results,     fn: function(){ handleFAQ('results'); } },
      { label: t.q.other,       fn: handleOther }
    ]);
  }

  /* ── FAQ HANDLER ──────────────────────────────────────────── */
  function handleFAQ(key) {
    $('lcQR').innerHTML = '';
    userMsg(t.q[key]);
    botMsg(t.a[key], 700).then(function() {
      setQR([{ label: t.back, fn: showMenu }]);
    });
  }

  function handleOther() {
    $('lcQR').innerHTML = '';
    userMsg(t.q.other);
    botMsg(t.other_msg, 700).then(function() {
      setQR([
        { label: t.email_cta, fn: function(){ window.location.href = window.LC_CONTACT_URL || '/pages/contact'; } },
        { label: t.back, fn: showMenu }
      ]);
    });
  }

  /* ── FREE TEXT INPUT ──────────────────────────────────────── */
  function handleInput() {
    var input = $('lcInput');
    var val = input.value.trim();
    if (!val) return;
    input.value = '';
    $('lcQR').innerHTML = '';
    userMsg(val);
    var v = val.toLowerCase();
    var key = null;
    if      (/ingr|compos|naturel|natural|zutaten|ingredi|formul/i.test(v))            key = 'ingredients';
    else if (/utilis|appl|comment|how|wie|hoe|como|come|usar|étapes|steps/i.test(v))   key = 'use';
    else if (/livr|deliv|ship|lieferung|levering|envío|consegna|entrega|délai/i.test(v)) key = 'delivery';
    else if (/retour|return|rückgabe|retour|devoluc|reso|devoluç|rembours/i.test(v))   key = 'returns';
    else if (/paiement|payment|zahlung|betaling|pago|pagamento|carte|card|visa/i.test(v)) key = 'payment';
    else if (/résultat|result|ergebnis|resultaat|resultado|risultato|tenu|72/i.test(v)) key = 'results';
    if (key) {
      setTimeout(function() { handleFAQ(key); }, 300);
    } else {
      botMsg(t.other_msg, 700).then(function() {
        setQR([
          { label: t.email_cta, fn: function(){ window.location.href = window.LC_CONTACT_URL || '/pages/contact'; } },
          { label: t.back, fn: showMenu }
        ]);
      });
    }
  }

  /* ── BUILD WIDGET ─────────────────────────────────────────── */
  function buildWidget() {
    var el = document.createElement('div');
    el.id = 'lcWidget';
    el.innerHTML =
      '<button class="lc-chat-btn" id="lcBtn" aria-label="Chat Lesly Curlz">' +
        '<span id="lcBtnIcon">💜</span>' +
        '<span class="lc-notif hidden" id="lcNotif"></span>' +
      '</button>' +
      '<div class="lc-chat-window" id="lcWin" role="dialog" aria-modal="true" aria-label="Chat Lesly Curlz">' +
        '<div class="lc-header">' +
          '<div class="lc-avatar">🌸</div>' +
          '<div class="lc-header-info">' +
            '<div class="lc-header-name" id="lcHName">' + t.name + '</div>' +
            '<div class="lc-header-status"><span class="lc-status-dot"></span><span id="lcHStatus">' + t.status + '</span></div>' +
          '</div>' +
          '<button class="lc-close-btn" id="lcCloseBtn" aria-label="Fermer">✕</button>' +
        '</div>' +
        '<div class="lc-messages" id="lcMsgs"></div>' +
        '<div class="lc-quick-replies" id="lcQR"></div>' +
        '<div class="lc-input-row">' +
          '<input class="lc-input" id="lcInput" type="text" placeholder="' + t.placeholder + '" autocomplete="off">' +
          '<button class="lc-send" id="lcSend" aria-label="Envoyer">›</button>' +
        '</div>' +
      '</div>';
    document.body.appendChild(el);
  }

  /* ── OPEN / CLOSE ─────────────────────────────────────────── */
  function openChat() {
    isOpen = true;
    $('lcWin').classList.add('open');
    $('lcNotif').classList.add('hidden');
    $('lcBtnIcon').textContent = '✕';
    $('lcBtn').style.background = 'linear-gradient(135deg,#5B21B6,#7C3AED)';
    if ($('lcMsgs').children.length === 0) {
      botMsg(t.greeting, 650).then(showMenu);
    }
    setTimeout(function(){ $('lcInput').focus(); }, 350);
  }

  function closeChat() {
    isOpen = false;
    $('lcWin').classList.remove('open');
    $('lcBtnIcon').textContent = '💜';
    $('lcBtn').style.background = '';
  }

  /* ── LANGUAGE SWITCH ─────────────────────────────────────── */
  function updateWidgetLang(newLang) {
    lang = newLang;
    t    = T[lang];
    var nameEl   = $('lcHName');
    var statusEl = $('lcHStatus');
    var input    = $('lcInput');
    if (nameEl)   nameEl.textContent   = t.name;
    if (statusEl) statusEl.textContent = t.status;
    if (input)    input.placeholder    = t.placeholder;
    $('lcMsgs').innerHTML = '';
    $('lcQR').innerHTML   = '';
    if (isOpen) botMsg(t.greeting, 500).then(showMenu);
  }

  /* ── INIT ─────────────────────────────────────────────────── */
  function init() {
    lang  = detectLang();
    t     = T[lang];
    email = window.LC_SHOP_EMAIL || 'contact@leslycurlz.com';
    buildWidget();

    $('lcBtn').addEventListener('click', function() { isOpen ? closeChat() : openChat(); });
    $('lcCloseBtn').addEventListener('click', closeChat);
    $('lcSend').addEventListener('click', handleInput);
    $('lcInput').addEventListener('keydown', function(e) { if (e.key === 'Enter') handleInput(); });

    /* Show notification ping after 3s */
    setTimeout(function() {
      if (!isOpen) $('lcNotif').classList.remove('hidden');
    }, 3000);

    /* React to language changes (lcSetLang modifie document.documentElement.lang) */
    new MutationObserver(function(mutations) {
      mutations.forEach(function(m) {
        if (m.attributeName === 'lang') {
          var raw     = (document.documentElement.lang || 'fr').toLowerCase().slice(0, 2);
          var newLang = LC_BROWSER_MAP[raw] ? raw : 'fr';
          if (newLang !== lang) updateWidgetLang(newLang);
        }
      });
    }).observe(document.documentElement, { attributes: true, attributeFilter: ['lang'] });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
